import {WS} from "./ws";
import {useAuthStore} from "../../../store/authStore";

interface SpeechRecognitionResult {
    text: string;
    is_final: boolean;
}

export class GoogleSpeechWS extends WS {
    public readonly name: string = 'GoogleSpeech';

    constructor(
        private serverWsUrl: string,
        ...args: ConstructorParameters<typeof WS>
    ) {
        super(...args);
    }

    async createConnection() {
        const idToken = useAuthStore.getState().idToken;
        if (!idToken) throw Error('No ID token found');

        const wsUrl = `${this.serverWsUrl}/ws/speech/google?token=${encodeURIComponent(idToken)}`;
        this.socket = new WebSocket(wsUrl);
        this.socket.binaryType = "arraybuffer";
        await new Promise<void>((resolve, reject) => {
            console.info(`[GoogleSpeechWS] connecting to:`, wsUrl);

            this.socket!.onclose = (event) => {
                const message = `[GoogleSpeechWS] closed. Code=${event.code}`;
                console.info(message);
                if (event.code !== 1000 && event.code !== 1005) {
                    this.close();
                    this.handleError(message)
                    reject(new Error(message));
                }
            };

            this.socket!.onerror = (error) => {
                this.handleError(`[GoogleSpeechWS] socket error: ${error}`)
                reject(error);
            };

            this.socket!.onopen = () => {
                console.info(`[GoogleSpeechWS] opened`);
                resolve();
            }

            this.socket!.onmessage = (event) => {
                console.info('[GoogleSpeechWS] Event:', event)
                try {
                    const data: SpeechRecognitionResult = JSON.parse(event.data);
                    if (data.text !== undefined) {
                        console.debug(`[GoogleSpeechWS] transcript:`,
                            `${data.is_final ? '[FINAL]' : '[INTERIM]'} ${data.text}`);
                        this.handleTranscript(data.text, data.is_final);
                    }
                } catch (e) {
                    console.warn(`[GoogleSpeechWS] invalid message:`, event.data);
                }
            };
        });
    }
}